import { useState } from "react";
import { CheckIcon, CopyIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

// CopyButton copies `value` and says so. navigator.clipboard is unavailable on
// insecure origins and can be denied outright, so a failure is reported rather
// than swallowed — the caller's text is always selectable as the fallback, and
// for invite codes a silent failure would lose the only copy that exists.
export function CopyButton({
  value,
  label = "Copy",
  size = "sm",
  variant = "outline",
}: {
  value: string;
  label?: string;
  size?: "sm" | "default" | "icon";
  variant?: "outline" | "ghost" | "secondary";
}) {
  const [state, setState] = useState<"idle" | "done" | "failed">("idle");

  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      setState("done");
      setTimeout(() => setState("idle"), 1500);
    } catch {
      setState("failed");
    }
  }

  return (
    <Button type="button" variant={variant} size={size} onClick={copy}>
      {state === "done" ? (
        <CheckIcon className="size-3.5" />
      ) : (
        <CopyIcon className="size-3.5" />
      )}
      {state === "failed" ? "Select and copy manually" : label}
    </Button>
  );
}
